/**
 * HomeDashboardPresenter
 * --
 */
import { useState } from 'react';
import { Content, Title, Row, Col } from 'components';
import { Divider, Button, Table, Radio, Spin, Tabs } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import { strCut, stringToMoneyFormat, isMobile } from 'utils';
import moment from 'moment';
//
import TotalSalesStatus from './components/TotalSalesStatus';
import OrderStatus from './components/OrderStatus';
import TotalSales from './components/TotalSales';
import StoreSales from './components/StoreSales';
import ShopSales from './components/ShopSales';
import NoticeList from './components/NoticeList';
import InquiryList from './components/InquiryList';
import ReviewList from './components/ReviewList';

/**----------------------------------------
 * [Component] 총관리자: 주문대시보드 - 프레젠터
 * ----------------------------------------
 */
const HomeDashboardPresenter = ({
  loading,
  startDate,
  endDate,
  orderList,
  storeSales,
  storeSales2,
  reviewList,
  inquiryList,

  permission,
  shopType,
}) => {
  // alert(permission);
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [currentTab, setCurrentTab] = useState(
    shopType === null ? 'ALL' : shopType
  );
  const [currentTab2, setCurrentTab2] = useState('NOTICE');
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  // console.log('[HomeDashboardPresenter] storeSales: ', storeSales);
  // console.log('[HomeDashboardPresenter] storeSales2: ', storeSales2);

  // JSX: start
  return (
    <Spin spinning={loading}>
      <Content
        maxWidth={'100%'}
        padding={isMobile ? 10 : 20}
        backgroundColor={'none'}
      >
        <Row>
          <Col x={24}>
            <Title
              size={3}
              style={{ marginBottom: 12 }}
              subButton={
                <span
                  style={{
                    color: '#717171',
                    fontWeight: 400,
                    fontSize: '0.85em',
                  }}
                >
                  {moment(endDate).format('YYYY년 MM월 DD일(ddd)')}
                </span>
              }
            >
              홈
            </Title>

            {/* === 현황 요약: start === */}
            {/* <OrderStatus
              loading={loading}
              data={orderList ? orderList[0] : []}
            /> */}
            <TotalSalesStatus
              loading={loading}
              mallList={orderList ?? []}
              storeList={storeSales ?? []}
              isMobile={isMobile()}
              permission={permission}
              shopType={shopType}
            />
            {/* === 현황 요약: end === */}

            <Tabs
              type="card"
              size={'large'}
              defaultActiveKey="1"
              onChange={setCurrentTab}
              style={{
                padding: 0,
                marginTop: 10,
              }}
              items={[
                ...(shopType === null
                  ? [
                      {
                        label: `전체 매출 현황`,
                        key: 'ALL',
                      },
                    ]
                  : []),
                ...(shopType !== 'STORE'
                  ? [
                      {
                        label: `쇼핑몰 매출 현황`,
                        key: 'SHOP',
                      },
                    ]
                  : []),
                ...(shopType !== 'SHOP'
                  ? [
                      {
                        label: `매장 매출 현황`,
                        key: 'STORE',
                      },
                    ]
                  : []),

                // {
                //   label: `일별 매출 현황`,
                //   key: 'DATE',
                // },

                // {
                //   label: `JM페이 사용현황`,
                //   key: 'JMPAY',
                // },
              ]}
            />

            <Content
              maxWidth={'100%'}
              padding={0}
              backgroundColor={'#fff'}
              style={{ marginTop: -16 }}
            >
              {currentTab === 'ALL' && (
                <TotalSales
                  list={[...(orderList ?? []), ...(storeSales ?? [])]}
                  mallList={orderList ?? []}
                  tableList={storeSales2 ?? []}
                  isMobile={isMobile()}
                  permission={permission}
                  shopType={shopType}
                />
              )}
              {currentTab === 'STORE' && (
                <StoreSales
                  data={storeSales}
                  shopInformationData={storeSales2}
                  isMobile={isMobile()}
                  permission={permission}
                  shopType={shopType}
                />
              )}
              {currentTab === 'SHOP' && (
                <ShopSales
                  data={orderList}
                  isMobile={isMobile()}
                  permission={permission}
                  shopType={shopType}
                />
              )}
              {/* {currentTab === 'DATE' && <TotalSalesChart />} */}
              {/* {currentTab === 'JMPAY' && <TotalSalesChart />} */}
            </Content>

            {/* ==== ==== */}
            <Tabs
              type="card"
              size={'large'}
              defaultActiveKey="1"
              onChange={setCurrentTab2}
              style={{
                padding: 0,
                marginTop: 15,
              }}
              items={[
                {
                  label: `공지사항`,
                  key: 'NOTICE',
                },
                ...(shopType !== 'STORE'
                  ? [
                      {
                        label: `답변 대기 문의(${inquiryList.length})`,
                        key: 'INQUIRY',
                      },
                      {
                        label: `승인 대기 리뷰(${reviewList.length})`,
                        key: 'REVIEW',
                      },
                    ]
                  : []),

                // {
                //   label: `일별 매출 현황`,
                //   key: 'DATE',
                // },

                // {
                //   label: `JM페이 사용현황`,
                //   key: 'JMPAY',
                // },
              ]}
            />
            <Content maxWidth={'100%'} padding={0} style={{ marginTop: -16 }}>
              {/* ===== 차트: start ===== */}
              <Row gutter={[5, 5]}>
                {/* === 공지: start === */}
                <Col x={24}>
                  {currentTab2 === 'NOTICE' && (
                    <NoticeList permission={permission} shopType={shopType} />
                  )}
                  {currentTab2 === 'INQUIRY' && (
                    <InquiryList
                      data={inquiryList}
                      permission={permission}
                      shopType={shopType}
                    />
                  )}
                  {currentTab2 === 'REVIEW' && (
                    <ReviewList
                      data={reviewList}
                      permission={permission}
                      shopType={shopType}
                    />
                  )}
                </Col>
                {/* === 공지: end === */}
              </Row>
            </Content>
            {/* ===== 차트: end ===== */}
          </Col>
        </Row>
      </Content>
    </Spin>
  ); // JSX: end
};

export default HomeDashboardPresenter;
